import { api } from '@smena/ui';

export interface SandboxTurn {
  role: 'guest' | 'agent';
  text: string;
  at: string;
}

export interface SandboxReply {
  history: SandboxTurn[];
  /** auto - агент ответил сам; draft - подготовил черновик; escalate - позвал оператора. */
  decision: 'auto' | 'escalate' | 'draft';
  escalationReason: string | null;
  intent: string | null;
}

export function fetchSandbox(): Promise<{ history: SandboxTurn[] }> {
  return api('/api/staff/sandbox');
}

export function sendSandboxMessage(text: string): Promise<SandboxReply> {
  return api('/api/staff/sandbox/message', { method: 'POST', json: { text } });
}

export function resetSandbox(): Promise<{ ok: true }> {
  return api('/api/staff/sandbox', { method: 'DELETE' });
}
